import React, { useState } from 'react'
import LeftSideMenu from './LeftSideMenu'
import validator from 'validator'
import { useAuth } from "./api/authStore"
import useMobile from './hooks/useMobile'
import MobileMenu from './components/MobileMenu'
import AnimatedBurgerIcon from './components/AnimatedBurgerIcon'

const ChangePassword = (props) => {

    const { getAccessTokenSilently } = useAuth()
    const { isMobile } = useMobile()

    const userData = props.user
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

    const [showOldPassword, setShowOldPassword] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [showRePassword, setShowRePassword] = useState(false)

    const [isError, showError] = useState(false)
    const [errorText, setErrorText] = useState("")

    const [passwordHelperText, setPasswordHelperText] = useState("")
    const [rePasswordHelperText, setRePasswordHelperText] = useState("")
    const [openRePassError, setRePassError] = useState(false)
    const [buttonDisable, setButtonStatus] = useState(true)

    const [open, setOpen] = useState(false)
   
    const [oldpasswd, setOldPassword] =  useState("")
    const [passwd, setPassword] =  useState("")
    const [repasswd, setRePassword] =  useState("")


    const [errorChangePassword, setErrorChangePassword] = useState(false)
    const [successChangePassword, setSuccessChangePassword] = useState(false)

    const handleSetErrorPasswordClose = () => {
        setErrorChangePassword(false)
    }

    const handleSetSuccessPasswordClose = () => {
        setSuccessChangePassword(false)
    }


    const handleClickShowOldPassword = () => setShowOldPassword((show) => !show)
    const handleClickShowPassword = () => setShowPassword((show) => !show)
    const handleClickShowRePassword = () => setShowRePassword((show) => !show)

    const handleMouseDownPassword = (event) => {
        event.preventDefault()
    }

    const handleChangePasswd = (e) => {
        setPassword(e.target.value)
    }
    
    const handleChangeOldPasswd = (e) => {
        setOldPassword(e.target.value)
    }

    const passwordValidate = (value) => {
  
        if (!validator.isStrongPassword(value, {
            minLength: 8, minLowercase: 1,
            minUppercase: 1, minNumbers: 1, minSymbols: 1
        })) {
            setPasswordHelperText("password should be at least 8 chars, 1 lower case, 1 upper case, 1 special chars, 1 number")
            return false
        } else {
            setPasswordHelperText("")
            return true
        }
    }

    const handleValidatePassword = (value) => {
        if (!passwordValidate(value) ){
            setOpen(true)
            setButtonStatus(true)
            setPassword(value)
        } else if(!validateRePassword(repasswd)){
            setRePassError(true)
            setButtonStatus(true)
        } else {
            setButtonStatus(false)
            setOpen(false)
            setRePassError(false)
            setPassword(value)
        }
    }

    const handleChangeRePasswd = (e) => {
        setRePassword(e.target.value)
    }

    const validateRePassword = (repassword) => {
        setRePassword(repassword)

        if(passwd !== repassword) {
            setRePasswordHelperText("Password and Re-password are not equal")
            setRePassError(true)
            setButtonStatus(true)
            
            return false
        } else {
            setRePassError(false)
            setRePasswordHelperText("")
            setButtonStatus(false)
            
            return true
        }
        
        
    }

    const hadleButtonClick = async() => {
        try {
            // console.log(passwd +' : '+repassword)
            await props.apiClient.setToken(getAccessTokenSilently()).changeUserPassword(userData.userID, passwd)
            // console.log(passwd +' : '+repassword)
            setSuccessChangePassword(true)
        } catch (e) {
            // console.log(response)
            showError(true)
            setErrorText("Erorr occurs, try again please.")
            setErrorChangePassword(true)
            // console.log(e)
        }
    }

    return (
        <div style={{ display: 'flex', height: '100vh' }}>
            {/* Десктопное меню */}
            {!isMobile && (
                <LeftSideMenu active={props.active} user={props.user} apiClient={props.apiClient}/>
            )}
            
            {/* Мобильное меню */}
            {isMobile && (
                <MobileMenu 
                    user={props.user} 
                    active={props.active} 
                    apiClient={props.apiClient}
                    isOpen={mobileMenuOpen}
                    onClose={() => setMobileMenuOpen(false)}
                />
            )}
            
            {/* Основной контент */}
            <div style={{
                width: isMobile ? '100%' : 'calc(100% - 280px)',
                marginLeft: isMobile ? '0' : '280px',
                padding: isMobile ? 'var(--spacing-md)' : 'var(--spacing-xl)',
                background: 'var(--dark-bg)',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column'
            }}>
                {/* Мобильная шапка */}
                {isMobile && (
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: 'var(--spacing-md) 0',
                        marginBottom: 'var(--spacing-lg)',
                        borderBottom: '1px solid var(--light-gray)',
                        width: '100%'
                    }}>
                        <AnimatedBurgerIcon 
                            isOpen={mobileMenuOpen}
                            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                        />
                        <h1 style={{
                            color: 'var(--text-light)',
                            fontSize: 'var(--text-lg)',
                            fontWeight: '700',
                            margin: '0',
                            background: 'var(--gradient-orange)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text'
                        }}>
                            Account
                        </h1>
                        <div style={{ width: '44px' }} /> {/* Spacer для центрирования */}
                    </div>
                )}
                
                {/* Контент с формой - центрируется в мобильной версии */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: isMobile ? 'center' : undefined,
                    flex: 1
                }}>
                    {/* Заголовок */}
                    <div style={{
                        marginBottom: isMobile ? 'var(--spacing-lg)' : 'var(--spacing-xl)',
                        width: isMobile ? '100%' : undefined,
                        textAlign: isMobile ? 'center' : undefined
                    }}>
                        {!isMobile && (
                            <h1 style={{
                                color: 'var(--text-light)',
                                fontSize: 'var(--text-3xl)',
                                fontWeight: '700',
                                margin: '0 0 var(--spacing-sm) 0',
                                background: 'var(--gradient-orange)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text'
                            }}>
                                Account: Change Password
                            </h1>
                        )}
                        {isMobile && (
                            <h2 style={{
                                color: 'var(--text-light)',
                                fontSize: 'var(--text-xl)',
                                fontWeight: '600',
                                margin: '0 0 var(--spacing-sm) 0',
                                background: 'var(--gradient-orange)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text'
                            }}>
                                Change Password
                            </h2>
                        )}
                        <p style={{
                            color: 'var(--text-muted)',
                            fontSize: isMobile ? 'var(--text-sm)' : 'var(--text-base)',
                            margin: '0'
                        }}>
                            {props.text}
                        </p>
                    </div>

                    {/* Форма */}
                    <div className="form-card" style={{
                        maxWidth: isMobile ? '100%' : '400px',
                        margin: '0 auto',
                        padding: isMobile ? 'var(--spacing-md)' : undefined,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        width: isMobile ? '100%' : undefined
                    }}>
                    
                    {/* Текущий пароль */}
                    <div style={{ 
                        marginBottom: 'var(--spacing-lg)',
                        width: isMobile ? '100%' : undefined
                    }}>
                        <label style={{
                            color: 'var(--text-light)',
                            fontSize: isMobile ? 'var(--text-base)' : 'var(--text-sm)',
                            fontWeight: '600',
                            marginBottom: 'var(--spacing-sm)',
                            display: 'block'
                        }}>
                            Current Password
                        </label>
                        <div style={{ position: 'relative' }}>
                            <input
                                type={showOldPassword ? 'text' : 'password'}
                                placeholder="Enter your current password"
                                value={oldpasswd}
                                onChange={handleChangeOldPasswd}
                                className="form-input"
                                style={{ 
                                    paddingRight: '50px',
                                    fontSize: isMobile ? 'var(--text-base)' : undefined,
                                    minHeight: isMobile ? '44px' : undefined
                                }}
                            />
                            <button
                                type="button"
                                onClick={handleClickShowOldPassword}
                                onMouseDown={handleMouseDownPassword}
                                style={{
                                    position: 'absolute',
                                    right: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: 'none',
                                    border: 'none',
                                    color: 'var(--text-muted)',
                                    cursor: 'pointer',
                                    padding: isMobile ? '8px' : '4px',
                                    fontSize: isMobile ? '20px' : '18px',
                                    minWidth: isMobile ? '44px' : undefined,
                                    minHeight: isMobile ? '44px' : undefined,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                {showOldPassword ? '👁️‍🗨️' : '👁️'}
                            </button>
                        </div>
                    </div>

                    {/* Новый пароль */}
                    <div style={{ 
                        marginBottom: 'var(--spacing-lg)',
                        width: isMobile ? '100%' : undefined
                    }}>
                        <label style={{
                            color: 'var(--text-light)',
                            fontSize: isMobile ? 'var(--text-base)' : 'var(--text-sm)',
                            fontWeight: '600',
                            marginBottom: 'var(--spacing-sm)',
                            display: 'block'
                        }}>
                            New Password
                        </label>
                        <div style={{ position: 'relative' }}>
                            <input
                                type={showPassword ? 'text' : 'password'}
                                placeholder="Enter your new password"
                                value={passwd}
                                onChange={handleChangePasswd}
                                onBlur={(e) => handleValidatePassword(e.target.value)}
                                className={`form-input ${open ? 'form-input-error' : ''}`}
                                style={{ 
                                    paddingRight: '50px',
                                    fontSize: isMobile ? 'var(--text-base)' : undefined,
                                    minHeight: isMobile ? '44px' : undefined
                                }}
                            />
                            <button
                                type="button"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                style={{
                                    position: 'absolute',
                                    right: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: 'none',
                                    border: 'none',
                                    color: 'var(--text-muted)',
                                    cursor: 'pointer',
                                    padding: isMobile ? '8px' : '4px',
                                    fontSize: isMobile ? '20px' : '18px',
                                    minWidth: isMobile ? '44px' : undefined,
                                    minHeight: isMobile ? '44px' : undefined,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                {showPassword ? '👁️‍🗨️' : '👁️'}
                            </button>
                        </div>
                        {passwordHelperText && (
                            <div className="form-error" style={{ minHeight: '20px' }}>
                                {passwordHelperText}
                            </div>
                        )}
                    </div>

                    {/* Подтверждение пароля */}
                    <div style={{ 
                        marginBottom: 'var(--spacing-lg)',
                        width: isMobile ? '100%' : undefined
                    }}>
                        <label style={{
                            color: 'var(--text-light)',
                            fontSize: isMobile ? 'var(--text-base)' : 'var(--text-sm)',
                            fontWeight: '600',
                            marginBottom: 'var(--spacing-sm)',
                            display: 'block'
                        }}>
                            Confirm New Password
                        </label>
                        <div style={{ position: 'relative' }}>
                            <input
                                type={showRePassword ? 'text' : 'password'}
                                placeholder="Confirm your new password"
                                value={repasswd}
                                onChange={handleChangeRePasswd}
                                onBlur={(e) => validateRePassword(e.target.value)}
                                className={`form-input ${openRePassError ? 'form-input-error' : ''}`}
                                style={{ 
                                    paddingRight: '50px',
                                    fontSize: isMobile ? 'var(--text-base)' : undefined,
                                    minHeight: isMobile ? '44px' : undefined
                                }}
                            />
                            <button
                                type="button"
                                onClick={handleClickShowRePassword}
                                onMouseDown={handleMouseDownPassword}
                                style={{
                                    position: 'absolute',
                                    right: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: 'none',
                                    border: 'none',
                                    color: 'var(--text-muted)',
                                    cursor: 'pointer',
                                    padding: isMobile ? '8px' : '4px',
                                    fontSize: isMobile ? '20px' : '18px',
                                    minWidth: isMobile ? '44px' : undefined,
                                    minHeight: isMobile ? '44px' : undefined,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                {showRePassword ? '👁️‍🗨️' : '👁️'}
                            </button>
                        </div>
                        {rePasswordHelperText && (
                            <div className="form-error" style={{ minHeight: '20px' }}>
                                {rePasswordHelperText}
                            </div>
                        )}
                    </div>

                    {/* Общая ошибка */}
                    {isError && (
                        <div className="form-error" style={{ marginBottom: 'var(--spacing-lg)', minHeight: '20px' }}>
                            {errorText}
                        </div>
                    )}

                    {/* Кнопка */}
                    <button
                        onClick={hadleButtonClick}
                        disabled={buttonDisable}
                        className={`btn btn-primary ${buttonDisable ? 'btn-disabled' : ''}`}
                        style={{ 
                            width: isMobile ? '100%' : '100%',
                            minHeight: isMobile ? '48px' : undefined,
                            fontSize: isMobile ? 'var(--text-base)' : undefined,
                            fontWeight: isMobile ? '600' : undefined
                        }}
                    >
                        Change Password
                    </button>
                    </div>
                </div>
            </div>

            {/* Уведомления */}
            {errorChangePassword && (
                <div style={{
                    position: 'fixed',
                    top: isMobile ? '10px' : '20px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 10001,
                    background: '#dc3545',
                    color: 'var(--white)',
                    border: '1px solid #dc3545',
                    borderRadius: 'var(--radius-md)',
                    padding: isMobile ? 'var(--spacing-sm) var(--spacing-md)' : 'var(--spacing-md) var(--spacing-lg)',
                    boxShadow: 'var(--shadow-card)',
                    minWidth: isMobile ? '280px' : '300px',
                    maxWidth: isMobile ? 'calc(100vw - 20px)' : undefined,
                    textAlign: 'center'
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 'var(--spacing-md)'
                    }}>
                        <span style={{ fontSize: 'var(--text-sm)', fontWeight: '500' }}>
                            Error changing password.
                        </span>
                        <button
                            onClick={handleSetErrorPasswordClose}
                            style={{
                                background: 'none',
                                border: 'none',
                                color: 'var(--white)',
                                fontSize: 'var(--text-lg)',
                                cursor: 'pointer',
                                padding: '0',
                                lineHeight: '1'
                            }}
                        >
                            ✕
                        </button>
                    </div>
                </div>
            )}

            {successChangePassword && (
                <div style={{
                    position: 'fixed',
                    top: isMobile ? '10px' : '20px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 10001,
                    background: '#28a745',
                    color: 'var(--white)',
                    border: '1px solid #28a745',
                    borderRadius: 'var(--radius-md)',
                    padding: isMobile ? 'var(--spacing-sm) var(--spacing-md)' : 'var(--spacing-md) var(--spacing-lg)',
                    boxShadow: 'var(--shadow-card)',
                    minWidth: isMobile ? '280px' : '300px',
                    maxWidth: isMobile ? 'calc(100vw - 20px)' : undefined,
                    textAlign: 'center'
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 'var(--spacing-md)'
                    }}>
                        <span style={{ fontSize: 'var(--text-sm)', fontWeight: '500' }}>
                            Password changed successfully!
                        </span>
                        <button
                            onClick={handleSetSuccessPasswordClose}
                            style={{
                                background: 'none',
                                border: 'none',
                                color: 'var(--white)',
                                fontSize: 'var(--text-lg)',
                                cursor: 'pointer',
                                padding: '0',
                                lineHeight: '1'
                            }}
                        >
                            ✕
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default ChangePassword